import {dateRangeSliderConfig} from './config/date-range'
import {worldMapConfig} from './config/world-map'

export const APP_NAME = 'L € X 3 R . $'
export const APP_TAGLINE = 'out of 195'

export const config = {
    prod: process.env.NODE_ENV === 'production',
    app: {
        title: process.env.REACT_APP__APP__TITLE || 'ʌ⠀ɪ⠀f⠀ə',
        description: process.env.REACT_APP__APP__DESCRIPTION || '7⠀€⠀X⠀.⠀L⠀€⠀X⠀3⠀R⠀.⠀$',
        og: {
            title: process.env.REACT_APP__APP__OG__TITLE || 'ʌ⠀ɪ⠀f⠀ə',
            description: process.env.REACT_APP__APP__OG__DESCRIPTION || '7⠀€⠀X⠀.⠀L⠀€⠀X⠀3⠀R⠀.⠀$',
            url: process.env.REACT_APP__APP__OG__URL || 'https://7ex.lex3r.com/$',
            imageUrl: process.env.REACT_APP__APP__OG__IMAGE_URL || 'https://7ex.lex3r.com/assets/avatars-R10bwDKGXu3zL0pv-pSUfjA-t500x500-512.jpg',
        },
        rootState: process.env.REACT_APP__ROOT_STATE || '$',
        qrCodeImage: process.env.REACT_APP__QR || 'qr-code-7-blank.png',
        shortYearSignature: process.env.REACT_APP__SHORT_YEAR_SIGNATURE || '',
        longYearSignature: process.env.REACT_APP__LONG_YEAR_SIGNATURE || '',
    },
    api: {
        url: process.env.REACT_APP__API__URL || '',
    },
    storage: {
        uploadProxyPath: process.env.REACT_APP__STORAGE__UPLOAD_PROXY_PATH || '',
    },
    analytics: {
        plausible: {
            domain: process.env.REACT_APP__ANALYTICS__PLAUSIBLE__DOMAIN || null,
            captureOnLocalhost: process.env.REACT_APP__ANALYTICS__PLAUSIBLE__CAPTURE_LOCALHOST === 'true',
        },
    },
    legal: {
        operatorName: process.env.REACT_APP__LEGAL__OPERATOR_NAME || '[Legal Name]',
        contactEmail: process.env.REACT_APP__LEGAL__CONTACT_EMAIL || 'legal@outof195.com',
    },
    include: {
        aife: process.env.REACT_APP__INCLUDE__AIFE === 'true',
        outof195: process.env.REACT_APP__INCLUDE__OUTOF195 === 'true',
        youtubeApi: process.env.REACT_APP__INCLUDE__YOUTUBE_API === 'true',
        soundcloudApi: process.env.REACT_APP__INCLUDE__SOUNDCLOUD_API === 'true',
    },
    debug: {
        visibility: process.env.REACT_APP__DEBUG__VISIBILITY,
        sharedStore: process.env.REACT_APP__DEBUG__SHARED_STORE,
    },
    profileCard: {
        likesStatEnabled: false
    },
    albums: {
        expandOnInit: false,
    },
    notifications: {
        showAllEnabled: false
    },
    grid: {
        advancedKeyboardControl: false,
    },
    worldMap: worldMapConfig,
    dateRangeSlider: dateRangeSliderConfig,
    maxColumnCount: 5
}
